import { Controller, useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';
import { EmailEditorProps } from './types';
import { ErrorText } from '../../../Scorecard/components/ScorecardQuestionAndAnswerSection';
import { Input } from 'sharedComponents/Input';
import { TextEditor } from 'sharedComponents/TextEditor/TextEditor';

export const EmailEditor: React.FC<EmailEditorProps> = ({ dataTestId }) => {
  const { control } = useFormContext();

  return (
    <>
      <Controller
        name="subject"
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          const handleChange = (newValue: string) => {
            onChange(newValue);
          };

          return (
            <Box>
              <Input
                hasError={Boolean(error)}
                placeholder="Email subject"
                value={value || ''}
                onChange={handleChange}
              />
              {Boolean(error) && <ErrorText dataTestId={`${dataTestId}-required-error`} />}
            </Box>
          );
        }}
      />
      <Controller
        name="message"
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          const handleChange = (newValue: string) => {
            onChange(newValue);
          };

          return (
            <Box>
              <TextEditor value={value || ''} onChange={handleChange} />
              {Boolean(error) && <ErrorText dataTestId={`${dataTestId}-required-error`} />}
            </Box>
          );
        }}
      />
    </>
  );
};
